var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17.877,
    viewBox: "0 0 15 17.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-map-pin",
    "data-name": "Icon feather-map-pin",
    transform: "translate(-4 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_114",
    "data-name": "Trac\\xE9 114",
    d: "M18.5,8.4c0,5.37-7,9.973-7,9.973s-7-4.6-7-9.973a7,7,0,0,1,14,0Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_115",
    "data-name": "Trac\\xE9 115",
    d: "M18.1,12.8a2.3,2.3,0,1,1-2.3-2.3,2.3,2.3,0,0,1,2.3,2.3Z",
    transform: "translate(-4.301 -4.397)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconOutline);
export default __webpack_public_path__ + "static/media/locationIconOutline.57b27a26ef82327810539dc7e1c3b0b4.svg";
export { ForwardRef as ReactComponent };